import { connect } from 'react-redux';

import { IStore } from './store';
import { USER_ROLE } from './user/types';

export interface IWithUserProps {
  user: {
    username: string;
    loggedIn: boolean;
    roles: USER_ROLE[];
  };
}

const mapStateToProps = ({ user }: IStore): IWithUserProps => ({
  user: {
    loggedIn: Boolean(user.username),
    username: user.username,
    roles: user.roles,
  },
});

export const withUser = (Component: any) =>
  connect(mapStateToProps)(Component) as any;



// WEBPACK FOOTER //
// ./src/services/withUser.tsx